import { getCssVariableValue } from 'shared/style-utils'
import './styles.scss'

const NotFound = ({ status, message, children }) => {
    const primaryColor = getCssVariableValue('--brand-primary-color')
    const indigoPrimaryColor = '#552373'

    return (
        <div className="error-page">
            <div className="error-page__svg">
                <div
                    className={`error-page__svg__city ${primaryColor === indigoPrimaryColor && 'error-page__svg__city__indigo'}`}></div>
                <div
                    className={`error-page__svg__car ${primaryColor === indigoPrimaryColor && 'error-page__svg__car__indigo'}`}></div>
            </div>
            <div className="d-flex flex-column align-items-center">
                <h2 className="error-page__status-code">{status}</h2>
                <h3 className="error-page__message">{message}</h3>
            </div>
            <div className="d-flex flex-column align-items-center">{children}</div>
        </div>
    )
}
NotFound.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.number]),
}

export default NotFound
